import React from "react";
import { Link } from "react-router-dom";

const HeroSection = ({ title, subtitle, image, cta, ctaLink = "/" }) => {
  return (
    <section className="relative w-full h-[620px] md:h-[720px] lg:h-[760px] overflow-hidden">
      {/* Background Image */}
      {image && (
        <div className="absolute inset-0">
          <img src={image} alt="Hero" className="w-full h-full object-cover" />
          {/* Overlay */}
          <div className="absolute inset-0 bg-black bg-opacity-40"></div>
        </div>
      )}

      {!image && (
        <div className="absolute inset-0 bg-gradient-to-r from-secondary to-blue-900"></div>
      )}

      {/* Content */}
      <div className="relative z-10 h-full flex items-center justify-center px-outer">
        <div className="text-center text-white max-w-3xl">
          <h1 className="font-rubik font-bold text-4xl md:text-5xl lg:text-6xl mb-4">
            {title}
          </h1>
          <p className="font-rubik font-light text-lg md:text-xl mb-8 text-gray-100">
            {subtitle}
          </p>
          {cta && (
            <Link to={ctaLink} className="btn-primary inline-block">
              {cta}
            </Link>
          )}
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
